// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { BSETBase } from '../Classes/BSETBase';
export class SystemComponent extends BSETBase {
  readonly systemComponentNodeType: string = "SystemComponent";
  suspendQuantityPropertyChanged: boolean;
  childTypicalOfHelperUniqueId: string;
  quantity: number;
  cartoon: string;
  isChildOfReadOnlySubsystem: boolean;
  isMaster: boolean;
  xCoOrdinate: number;
  yCoOrdinate: number;
  zIndex: number;
  flipX: number;
  flipY: number;
  rotationAngle: number;
  digitalInput: number;
  digitalOutput: number;
  analogInput: number;
  analogOutput: number;
  digitalVirtual: number;
  analogVirtual: number;
  graphic: number;
  alarm: number;
  trend: number;
  integration: number;
  fln: number;
  isTec: number;
  addressable: number;
  vesdaCheck: boolean;
  vesdaNode: number;
  vesdaElement: number;
  na: number;
  all: number;
  controllerChildType: string;
  notes: string;
  isSystemComponentSelected: boolean;
  costOverride: boolean;
  isCostOverride: boolean;
}
